import {
  Box,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import LoadingSpinner from "./loading-spinner";
import api from "../../API/api";
import UserDetailPurchaseItem from "./components/user-detail-purchase-item";
import UserPurchasesPagination from "./components/user-purchases-pagination";

const UserDetailPurchases = ({ user }) => {
  const [loading, setLoading] = useState(true);

  const theme = useTheme();

  const isBelowMD = useMediaQuery(theme.breakpoints.down("md"));

  const [purchases, setPurchases] = useState([]);
  const [paginateOptions, setPaginateOptions] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1,
  });

  const getPurchaces = (page, perPage, filters = {}) => {
    api
      .appUsersPurchases({
        id: user.id,
        page: page,
        perPage: perPage,
        ...filters,
      })
      .then((res) => {
        if (res.data.success) {
          let localPurchaces = res.data.purchases;
          setPurchases(localPurchaces.data);

          delete localPurchaces.data;
          setPaginateOptions({
            ...localPurchaces,
          });
        }
        setLoading(false);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePageChange = (page) => {
    setPaginateOptions({ ...paginateOptions, current_page: page });
  };

  const handlePerPageChange = (perPage) => {
    setPaginateOptions({ ...paginateOptions, per_page: perPage });
  };

  useEffect(() => {
    if (user) {
      getPurchaces();
    }
  }, [user, paginateOptions.current_page, paginateOptions.per_page]);

  return (
    <Stack
      direction={"column"}
      spacing={2}
      mt={2}
      bgcolor={"#f0f0f0"}
      borderRadius={2}
      color={"#424242"}
      flexGrow={1}
      p={2}
      overflow={"hidden"}
    >
      {loading && <LoadingSpinner />}
      {!loading && (
        <>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant="h6">Purchases</Typography>
            {purchases.length > 0 && (
              <Box>
                <UserPurchasesPagination
                  paginationOptions={paginateOptions}
                  onPageChange={handlePageChange}
                />
              </Box>
            )}
          </Stack>
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            sx={{
              overflowY: "scroll",
              height: isBelowMD ? "60vh" : "60vh",
            }}
          >
            {purchases.length === 0 && (
              <Typography variant="body1">No purchases found</Typography>
            )}
            {purchases.map((purchase) => (
              <UserDetailPurchaseItem key={purchase.id} purchase={purchase} />
            ))}
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default UserDetailPurchases;
